import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import YoutubePlayer from '@spa/shared/components/YoutubePlayer';
var VideoSection = function VideoSection(_ref) {
  var _video$url;
  var video = _ref.video;
  if (!(video !== null && video !== void 0 && video.url)) {
    return null;
  }
  var _video$url$split = (_video$url = video.url) === null || _video$url === void 0 ? void 0 : _video$url.split('v='),
    _video$url$split2 = _slicedToArray(_video$url$split, 2),
    videoKey = _video$url$split2[1];
  return __jsx(YoutubePlayer, {
    videoKey: videoKey,
    styles: 'background-image: none;',
    withControls: true
  });
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var video = _ref2.offer.offerAggregate.property_aggregate.property.video;
  return {
    video: video
  };
};
export default connect(mapStateToProps)(VideoSection);